import { AirportsInt } from "@interfaces/";

export class Airports {
    static destinations: AirportModel[] = [];
    static findAriportByCode(d: string): AirportModel {
        if(this.getAirports().length === 0){
            return new AirportModel();
        }
      return this.getAirports().find(
            (res: AirportModel) =>  {
                return res.code === d
            })!;


    }

    static setAirports(destinations: AirportModel[]) {
        this.destinations = destinations;
    }

    static getAirports(): AirportModel[]{
        return this.destinations;
    }
}

export class AirportModel implements AirportsInt {
    code: string = "";
    country3: string = "";
    searchCriteria: string[] = [];
    en_US: string = "";
    ja_JP: string = "";
    kr_KR: string = "";
    zh_CN: string = "";
    du_NL: string = "";
    pt_PT: string = "";
    fr_FR: string = "";
    es_MX: string = "";
    constructor (
        airport?: AirportsInt
    ) {
        if ( airport ) {
            this.code = airport.code;
            this.country3 = airport.country3;
            this.searchCriteria = airport.searchCriteria;
            this.en_US = airport.en_US;
            this.ja_JP = airport.ja_JP;
            this.kr_KR = airport.kr_KR;
            this.zh_CN = airport.zh_CN;
            this.du_NL = airport.du_NL;
            this.pt_PT = airport.pt_PT;
            this.fr_FR = airport.fr_FR;
            this.es_MX = airport.es_MX;
        }
    }

}
